// analytics
export const BOLD_BUTTON_SUFFIX = 'notes-bold-button';
export const ITALIC_BUTTON_SUFFIX = 'notes-italic-button';
export const LINK_BUTTON_SUFFIX = 'notes-link-button';
export const CREATE_LINK_SUFFIX = 'notes-insert-link-button';
export const EDIT_LINK_TITLE_SUFFIX = 'notes-edit-link-title-button';
export const UPDATE_LINK_URL_SUFFIX = 'notes-update-url-button';
export const DELETE_LINK_URL_SUFFIX = 'notes-delete-url-button';
export const ORDERED_LIST_BUTTON_SUFFIX = 'notes-ordered-list-button';
export const BULLET_LIST_BUTTON_SUFFIX = 'notes-bullet-list-button';
export const DIVIDER_BUTTON_SUFFIX = 'notes-divider-button';
export const CONFIRM_SEND_NOTE_BUTTON = 'confirm-send-note-button';
export const SEND_NOTE_BUTTON = 'send-note-button';
export const CANCEL_SEND_NOTE_BUTTON = 'cancel-send-note-button';
export const TRANSCRIPT_ELEMENT = 'transcript-element';
export const RESUME_AUTO_SCROLL_BUTTON = 'resume-auto-scroll-button';
export const TRANSCRIPT_BLOCK = 'transcript-block';
// styles
export const TOOLBAR_CONTROL_HEIGHT = '1.75rem';
//# sourceMappingURL=consts.js.map